import * as PIXI from "pixi.js";
import { Spine } from "@esotericsoftware/spine-pixi-v8";
import { EnumEventBus, EventBus } from "../EventBus";


const app_width = 1782;
const app_height = 781;


export class TransitionCanvas {
  app: PIXI.Application = new PIXI.Application();
  transition!: Spine;
  canvas!: HTMLCanvasElement;
  constructor() {
    (async () => await this.init())();

    EventBus.on(EnumEventBus.startTransitionAnim1, () => this.startTransitionAnim("animation1"));
    EventBus.on(EnumEventBus.startTransitionAnim2, () => this.startTransitionAnim("animation2"));
    EventBus.on(EnumEventBus.setTranstionAnim2, () => this.transition.state.setAnimation(0, "animation2", false))
  }
  async init() {
      await this.app.init({
        resizeTo: window,
        backgroundAlpha: 0,
        resolution: 2,
      });
      document.body.appendChild(this.app.canvas);
      this.canvas = this.app.renderer.canvas;
      this.addStyle();
      this.listenSize();
      this.setDisplay(false);
  }
  setDisplay = (v: boolean) => this.canvas.style.display = v ? "block" : "none";
  listenSize = () => window.addEventListener("resize", () => this.resizeTransition());
  
  createTransition() {
    this.transition = Spine.from({skeleton:"bonus_transition_json",atlas:"bonus_transition_atlas"})
    this.transition.state.setAnimation(0, "animation1", false); 
    this.transition.state.timeScale = 0;
    
    this.resizeTransition();
    
    this.app.stage.addChild(this.transition);

    this.transition.state.addListener({ 
      complete: () => {
        if(this.transition.state.getCurrent(0) && this.transition.state.getCurrent(0)?.animation?.name == "animation1"){
          EventBus.emit(EnumEventBus.showBonus);
        } else {
          this.setDisplay(false);
          EventBus.emit(EnumEventBus.logoAnimAllsuper);
        };
      }
    });
  }
  resizeTransition() {
    if (!this.transition) return;

    const screenWidth = window.innerWidth;
    const screenHeight = window.innerHeight;

    const sX = screenWidth / app_width;
    const sY = screenHeight / app_height;
    const s = Math.max(sX, sY);

    this.transition.scale.set(s);
    this.transition.x = screenWidth / 2;
    this.transition.y = screenHeight / 2;
  }
  startTransitionAnim(animName: string) {
    this.setDisplay(true);
    this.transition.state.setAnimation(0, animName, false);
    this.transition.state.timeScale = 1;
  }
  addStyle() {  
    this.canvas.style.zIndex = "5";
    this.canvas.style.position = "absolute";
    this.canvas.style.top = "0";
    this.canvas.style.left = "0";
    this.canvas.style.width = "100%";
    this.canvas.style.height = "100%";
    this.canvas.style.pointerEvents = "none";
  }
}